import {
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
  SUBMIT_REIMBURSEMENT_REQUEST,
  SUBMIT_REIMBURSEMENT_SUCCESS,
  SUBMIT_REIMBURSEMENT_FAILURE,
  CHECK_ACCOUNT_REQUEST,
  CHECK_ACCOUNT_SUCCESS,
  CHECK_ACCOUNT_FAILURE,
  CLICK_EMAIL_US_REQUEST,
  CLICK_EMAIL_US_SUCCESS,
  CLICK_EMAIL_US_FAILURE,
} from '../types';

const initialState = {
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
    case SUBMIT_REIMBURSEMENT_REQUEST:
    case CHECK_ACCOUNT_REQUEST:
    case CLICK_EMAIL_US_REQUEST:
      return {
        show: true,
      };
    case HIDE_GLOBAL_LOADER:
    case SUBMIT_REIMBURSEMENT_SUCCESS:
    case SUBMIT_REIMBURSEMENT_FAILURE:
    case CHECK_ACCOUNT_SUCCESS:
    case CHECK_ACCOUNT_FAILURE:
    case CLICK_EMAIL_US_SUCCESS:
    case CLICK_EMAIL_US_FAILURE:
      return {
        show: false,
      };

    default:
      return state;
  }
};
